<template>
  <div class="security-roll-call-history">
    <v-container class="my-5">
      <v-layout row wrap align-center justify-center fill-height class="mb-4">
        <v-flex xs12>
          <v-card class="elevation-2">
            <v-toolbar flat dense color="grey lighten-3">
              <v-icon color="grey darken-2" class="mr-2">filter_list</v-icon>
              <v-toolbar-title class="subheading grey--text text--darken-2">Filtros</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pa-4">
              <v-layout row wrap align-center>
                <!-- Filtros -->
                <v-flex xs12 sm6 md3 class="px-2">
                  <v-menu
                    ref="menuDate"
                    v-model="showDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="filterDate"
                        label="Fecha"
                        prepend-inner-icon="event"
                        readonly
                        v-on="on"
                        solo
                        flat
                        hide-details
                        background-color="grey lighten-4"
                        class="filter-field"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filterDate"
                      @input="showDateMenu = false; loadHistory()"
                      :max="today"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12 sm6 md3 class="px-2">
                  <v-text-field
                    v-model="filterGuardName"
                    label="Buscar guardia"
                    prepend-inner-icon="search"
                    solo
                    flat
                    hide-details
                    clearable
                    background-color="grey lighten-4"
                    class="filter-field"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md3 class="px-2">
                  <v-select
                    v-model="filterCompany"
                    :items="companies"
                    item-text="name"
                    item-value="id"
                    label="Filtrar por empresa"
                    prepend-inner-icon="business"
                    clearable
                    @change="loadHistory()"
                    solo
                    flat
                    hide-details
                    background-color="grey lighten-4"
                    class="filter-field"
                  ></v-select>
                </v-flex>

                <!-- Botones de acción -->
                <v-flex xs12 class="text-xs-right px-2 mt-4">
                  <v-btn
                    color="grey darken-1"
                    dark
                    small
                    @click="resetFilters"
                    class="mr-2"
                  >
                    <v-icon left>refresh</v-icon>
                    Limpiar
                  </v-btn>
                  <v-btn
                    color="primary"
                    dark
                    small
                    @click="downloadPDF"
                    :disabled="filteredAttendance.length === 0"
                    class="mr-2"
                  >
                    <v-icon left>picture_as_pdf</v-icon>
                    PDF
                  </v-btn>
                  <v-btn
                    color="success"
                    dark
                    small
                    @click="downloadExcel"
                    :disabled="filteredAttendance.length === 0"
                  >
                    <v-icon left>table_chart</v-icon>
                    Excel
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>


      <!-- Tabla de registros -->
      <v-layout row wrap>
        <v-flex xs12>
          <v-card class="elevation-2">
            <v-card-title>
              Registros ({{ filteredAttendance.length }})
            </v-card-title>

            <v-data-table
              :headers="headers"
              :items="filteredAttendance"
              :loading="isLoading"
              class="elevation-0"
            >
              <template slot="items" slot-scope="props">
                <tr style="cursor: pointer;" @click="openDetail(props.item)">
                <td class="text-xs-center">
                  <v-icon
                    small
                    color="primary"
                    class="mr-2"
                  >
                    visibility
                  </v-icon>
                </td>
                <td>{{ props.item.guardia_nombre }}</td>
                <td>{{ props.item.guardia_badge || 'N/A' }}</td>
                <td>{{ props.item.empresa_nombre }}</td>
                <td>{{ props.item.fecha }}</td>
                <td class="text-xs-center">
                  <v-chip color="info" text-color="white" small>
                    {{ props.item.hora_entrada.substring(0, 5) }}
                  </v-chip>
                </td>
                <td class="text-xs-center">
                  <v-chip
                    v-if="props.item.hora_salida"
                    color="warning"
                    text-color="white"
                    small
                  >
                    {{ props.item.hora_salida.substring(0, 5) }}
                  </v-chip>
                  <span v-else class="grey--text">—</span>
                </td>
                <td class="text-xs-center">
                  <v-chip
                    :color="props.item.estado === 'entrada' ? 'warning' : 'success'"
                    text-color="white"
                    small
                  >
                    {{ props.item.estado === 'entrada' ? 'En turno' : 'Completado' }}
                  </v-chip>
                </td>
                </tr>
              </template>

              <template v-slot:no-results>
                <v-alert :value="true" color="error" icon="warning" class="ma-4">
                  No hay registros que coincidan con los filtros
                </v-alert>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>

      <!-- Modal con el detalle del registro -->
      <v-dialog v-model="showDetailDialog" max-width="700px">
        <v-card v-if="selectedRecord">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Detalle del Registro</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon color="white" flat @click="showDetailDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-4">
            <div class="title mb-2">{{ selectedRecord.guardia_nombre }}</div>
            <div class="body-2 grey--text mb-3">
              {{ selectedRecord.empresa_nombre }} • {{ selectedRecord.fecha }}
            </div>
            <v-layout row wrap>
              <v-flex xs12 md6 class="px-3 mb-4">
                <div class="body-2 font-weight-bold mb-2">Foto de Entrada</div>
                <img
                  v-if="selectedRecord.foto_entrada"
                  :src="selectedRecord.foto_entrada"
                  alt="Foto entrada"
                  style="max-width: 100%; max-height: 300px; border-radius: 8px;"
                >
                <div v-else class="grey--text text-xs-center py-5">
                  Sin foto de entrada
                </div>
              </v-flex>

              <v-flex xs12 md6 class="px-3 mb-4">
                <div class="body-2 font-weight-bold mb-2">Foto de Salida</div>
                <img
                  v-if="selectedRecord.foto_salida"
                  :src="selectedRecord.foto_salida"
                  alt="Foto salida"
                  style="max-width: 100%; max-height: 300px; border-radius: 8px;"
                >
                <div v-else class="grey--text text-xs-center py-5">
                  Sin registro de salida
                </div>
              </v-flex>

              <v-flex xs12 class="px-3">
                <v-divider class="my-2"></v-divider>
                <div class="caption grey--text">
                  <strong>ID Registro:</strong> {{ selectedRecord.id }}
                </div>
                <div class="caption grey--text mt-1">
                  <strong>Duración:</strong>
                  {{ durationLabel(selectedRecord) }}
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="justify-center py-3">
            <v-btn color="primary" @click="showDetailDialog = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import { securityService } from '@/services/securityService'

export default {
  name: 'SecurityRollCallHistory',
  data() {
    return {
      headers: [
        { text: 'Acción', align: 'center', value: 'actions', sortable: false },
        { text: 'Guardia', align: 'left', value: 'guardia_nombre', sortable: true },
        { text: 'Placa', align: 'left', value: 'guardia_badge', sortable: true },
        { text: 'Empresa', align: 'left', value: 'empresa_nombre', sortable: true },
        { text: 'Fecha', align: 'left', value: 'fecha', sortable: true },
        { text: 'Entrada', align: 'center', value: 'hora_entrada', sortable: true },
        { text: 'Salida', align: 'center', value: 'hora_salida', sortable: true },
        { text: 'Estado', align: 'center', value: 'estado', sortable: true }
      ],
      attendance: [],
      companies: [],
      isLoading: false,
      filterDate: new Date().toISOString().split('T')[0],
      today: new Date().toISOString().split('T')[0],
      filterGuardName: '',
      filterCompany: null,
      showDateMenu: false,
      showDetailDialog: false,
      selectedRecord: null
    }
  },
  computed: {
    filteredAttendance() {
      return this.attendance.filter(record => {
        // Filtro por nombre de guardia
        if (this.filterGuardName && !record.guardia_nombre.toLowerCase().includes(this.filterGuardName.toLowerCase())) {
          return false
        }

        return true
      })
    }
  },
  methods: {
    async loadHistory() {
      this.isLoading = true
      const result = await securityService.getDailyAttendance({
        date: this.filterDate,
        empresa_id: this.filterCompany || undefined
      })

      if (result.success && result.data) {
        this.attendance = result.data.map(item => ({
          id: item.attendance_id,
          guardia_nombre: item.guardia_nombre,
          guardia_badge: item.guardia_badge,
          empresa_nombre: item.empresa_asignada_nombre,
          fecha: result.date,
          hora_entrada: item.entrada ? item.entrada.hora : null,
          hora_salida: item.salida ? item.salida.hora : null,
          foto_entrada: item.entrada ? item.entrada.foto : null,
          foto_salida: item.salida ? item.salida.foto : null,
          total_horas: item.total_horas,
          estado: item.estado
        }))
      }
      this.isLoading = false
    },
    async loadCompanies() {
      const result = await securityService.getActiveCompanies()
      if (result.success) {
        this.companies = result.data
      }
    },
    openDetail(record) {
      this.selectedRecord = record
      this.showDetailDialog = true
    },
    resetFilters() {
      this.filterDate = new Date().toISOString().split('T')[0]
      this.filterGuardName = ''
      this.filterCompany = null
      this.loadHistory()
    },
    calculateDuration(entrada, salida) {
      const [hE, mE] = entrada.substring(0, 5).split(':').map(Number)
      const [hS, mS] = salida.substring(0, 5).split(':').map(Number)
      const minEntrada = hE * 60 + mE
      const minSalida = hS * 60 + mS
      const diffMin = minSalida - minEntrada
      const horas = Math.floor(diffMin / 60)
      const minutos = diffMin % 60
      return `${horas}:${String(minutos).padStart(2, '0')} horas`
    },
    durationLabel(record) {
      if (record.total_horas) return `${record.total_horas} horas`
      if (record.hora_salida) return this.calculateDuration(record.hora_entrada, record.hora_salida)
      return 'En progreso'
    },
    downloadPDF() {
      const doc = new jsPDF({ orientation: 'landscape' })
      const now = new Date().toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })

      doc.setFontSize(16)
      doc.setTextColor(33, 33, 33)
      doc.text('Historial de Pase de Lista', 14, 18)
      doc.setFontSize(10)
      doc.setTextColor(100)
      doc.text(`Fecha: ${now}`, 14, 26)
      doc.text(`Periodo: ${this.filterDate}`, 14, 32)

      const rows = this.filteredAttendance.map(r => [
        r.guardia_nombre,
        r.empresa_nombre,
        r.fecha,
        r.hora_entrada.substring(0, 5),
        r.hora_salida ? r.hora_salida.substring(0, 5) : '-',
        r.estado === 'entrada' ? 'En turno' : 'Completado'
      ])

      doc.autoTable({
        startY: 38,
        head: [['Guardia', 'Empresa', 'Fecha', 'Entrada', 'Salida', 'Estado']],
        body: rows,
        headStyles: { fillColor: [25, 118, 210], textColor: 255, fontStyle: 'bold' },
        alternateRowStyles: { fillColor: [235, 245, 255] },
        styles: { fontSize: 9, cellPadding: 4 }
      })

      doc.save(`pase_lista_${Date.now()}.pdf`)
    },
    downloadExcel() {
      // Descarga como CSV (compatible con Excel)
      let csv = 'Guardia,Empresa,Fecha,Entrada,Salida,Estado\n'
      this.filteredAttendance.forEach(r => {
        csv += `"${r.guardia_nombre}","${r.empresa_nombre}","${r.fecha}","${r.hora_entrada.substring(0, 5)}","${r.hora_salida ? r.hora_salida.substring(0, 5) : '-'}","${r.estado === 'entrada' ? 'En turno' : 'Completado'}"\n`
      })

      const link = document.createElement('a')
      link.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`
      link.download = `pase_lista_${Date.now()}.csv`
      link.click()
    }
  },
  mounted() {
    this.loadCompanies()
    this.loadHistory()
  }
}
</script>

<style scoped>
.v-data-table {
  background: white;
}

.filter-field >>> .v-input__control > .v-input__slot {
  border-radius: 8px;
}
</style>
